import { defineFcm } from '../shared/factory';

export const FCM_ADVOCATES_PSF = defineFcm('advocates_psf').asBoolean().withDefault(false).toConfig();
